import { getToken } from "firebase/messaging";
import Config from "./Config";
import { messaging } from "./firebase";
import { getCookie, setCookie } from "./Utils";
import { removeDevice, saveDevice } from "./notificationApi";

// Browser push for this device. Everything is optional: with no Firebase settings, no browser
// support or permission refused, the bell and inbox still work (they only need the API).

export const pushSupported = () =>
    Boolean(messaging && Config.KEYS.VAPID_KEY && typeof window !== "undefined" && "serviceWorker" in navigator && "Notification" in window);

// "unsupported" | "default" (not asked yet) | "granted" | "denied"
export const permissionState = () => (pushSupported() ? Notification.permission : "unsupported");

export const askPermission = async () => {
    if (!pushSupported()) return "unsupported";
    try {
        return await Notification.requestPermission();
    } catch (error) {
        return Notification.permission;
    }
};

// "Chrome on Windows", shown to the person so they can recognise their own devices.
export const deviceLabel = () => {
    const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
    const browser = /Edg\//.test(ua) ? "Edge" : /OPR\//.test(ua) ? "Opera" : /Firefox\//.test(ua) ? "Firefox" : /Chrome\//.test(ua) ? "Chrome" : /Safari\//.test(ua) ? "Safari" : "Browser";
    const os = /Windows/.test(ua) ? "Windows" : /Android/.test(ua) ? "Android" : /iPhone|iPad/.test(ua) ? "iOS" : /Mac OS X/.test(ua) ? "Mac" : /Linux/.test(ua) ? "Linux" : "";
    return os ? `${browser} on ${os}` : browser;
};

// Gets this browser's push token (Firebase refreshes it when it rotates) and saves it as one
// of the signed-in person's devices. Needs permission already granted.
export const registerThisDevice = async () => {
    try {
        if (!pushSupported() || Notification.permission !== "granted") return "";
        const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        const token = await getToken(messaging, { vapidKey: Config.KEYS.VAPID_KEY, serviceWorkerRegistration: registration });
        if (!token) return "";
        setCookie("fcmToken", token);
        await saveDevice({ token, platform: "web", label: deviceLabel() });
        return token;
    } catch (error) {
        console.warn("[push] device registration skipped:", error?.message);
        return "";
    }
};

// Sign-out: stop this browser receiving the person's notifications.
export const unregisterThisDevice = async () => {
    try {
        const token = getCookie("fcmToken");
        if (token) await removeDevice(token);
    } catch (error) {
        /* signing out must never wait on this */
    }
};
